import { render, staticRenderFns } from "./PuntoVenta.vue?vue&type=template&id=6ad4dee4&scoped=true&"
import script from "./PuntoVenta.vue?vue&type=script&lang=js&"
export * from "./PuntoVenta.vue?vue&type=script&lang=js&"
import style0 from "./PuntoVenta.vue?vue&type=style&index=0&id=6ad4dee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4dee4",
  null
  
)

export default component.exports